import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import {Amplify} from "aws-amplify";
import {environment} from "./app/environments/environment";

Amplify.configure(
  {
    Auth: {
      Cognito: {
        userPoolId: environment.cognito.userPoolId,  // Replace with your User Pool ID
        userPoolClientId: environment.cognito.userPoolClientId,  // Replace with your App Client ID

        // OPTIONAL - Hosted UI configuration
        loginWith: {
          oauth: {
            domain: environment.cognito.hostedUiDomain,  // Replace with your Cognito domain
            scopes: ['email', 'profile', 'openid'],
            redirectSignIn: ['http://localhost:4000/callback', `${environment.baseUrl}/callback`],  // Replace with your app's sign-in callback URL
            redirectSignOut: ['http://localhost:4000', environment.baseUrl],  // Replace with your app's sign-out callback URL
            responseType: 'code'  // "code" for Authorization Code Grant
          },
        }
      }
    }
  }
)

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
